import { EExtensionStep, EVerifyMethod } from '../../common/enum';
import Action from '../actions/global';

const initialState = {
    repairAccount: '',
    methodList: [],
    countryProvinceList: [],
    phoneAreaOptions: [],
    dateReviewShowMore: false,
    ifPayUser: false,
    hasStatus: false,
    originalUid: '',
    guideInfoContactPersons: [], // 账号的最近联系人
    guideInfoOnceBindPhone: '', // 账号的曾绑定掩码账号
    bindPhone: '', // 当前账号的绑定手机
    inRepair: false, // 是否已有修复任务
    submitClickCount: 0,
    verifyPhoneMethod: 'VerifyBox', // 验证方式
    externalVerifyList: [
        EExtensionStep.EXT_CREDIT_SCORE_JUDGE, //芝麻信用分方式
        EExtensionStep.EXT_FACE_RECOGNITION, // 人脸识别 
    ],
};

export default (state = initialState, action: { type: string, playload: any }) => {
    switch (action.type) {
        case Action.UPDATE_REPAIR_ACCOUNT: {
            return {
                ...state,
                repairAccount: action.playload
            }
        }
        case Action.UPDATE_REPAIR_METHOD_LIST: {
            return {
                ...state,
                methodList: action.playload
            }
        }
        case Action.UPDATE_COUNTRY_PROVINCE_LIST: {
            const { countList, proinceList } = action.playload;
            const [_, ...rest] = countList;
            const overseasObj = {
                id: "2",
                level: "COUNTRY",
                name: "海外",
                options: rest
            }
            return {
                ...state,
                countryProvinceList: [overseasObj, ...proinceList]
            }
        }
        case Action.UPDATE_PHONE_AREA_OPTIONS: {
            return {
                ...state,
                phoneAreaOptions: action.playload
            }
        }
        case Action.UPDATE_DATEREVIEW_SHOW_MORE: {
            return {
                ...state,
                dateReviewShowMore: action.playload
            }
        }
        case Action.UPDATE_IF_PAY_USER: {
            return {
                ...state,
                ifPayUser: action.playload
            }
        }
        case Action.UPDATE_HAS_STATUS:  {
            return {
                ...state,
                hasStatus: action.playload
            }
        }
        case Action.UPDATE_ORIGINALUID: {
            return {
                ...state,
                originalUid: action.playload
            }
        }
        case Action.UPDATE_GUIDE_INFO_CONTACT_PERSONS: {
            return {
                ...state,
                guideInfoContactPersons: action.playload
            }
        }
        case Action.UPDATE_GUIDE_INFO_ONCE_BIND_PHONE: {
            return {
                ...state,
                guideInfoOnceBindPhone: action.playload
            }
        }
        case Action.UPDATE_BIND_PHONE: {
            return {
                ...state,
                bindPhone: action.playload
            }
        }
        case Action.UPDATE_IN_REPAIR: {
            return {
                ...state,
                inRepair: action.playload
            }
        }
        case Action.UPDATE_SUBMIT_CLICK_COUNT: {
            return {
                ...state,
                submitClickCount: action.playload
            }
        }
        case Action.UPDATE_VERIFY_PHONE_METHOD: {
            return {
               ...state,
                verifyPhoneMethod: action.playload
            }
        }
        case Action.UPDATE_EXTERNAL_VERIFY_LIST: {
            return {
                ...state,
                externalVerifyList: action.playload
            }
        }
        default: return state;
    }
}
